import React from 'react';
import './AboutPage.css';

const AboutPage: React.FC = () => {
  return (
    <div className="about-page">
      <div className="about-page-content">
        <div className="about-header">
          <h1>Quirke Trophies Ltd</h1>
          <p className="about-tagline">Because Excellence Deserves Reward</p>
        </div>
        
        <div className="about-section">
          <p>
            Quirke Trophies, founded by John Quirke, Jeweller, Cahir has, for over 50 years, been an 
            integral part of community life in South Tipperary. During this time, we have been proud 
            to share in the successes of our customers and to help to celebrate their achievements in 
            the arenas of sport, education, community activism and the Arts.
          </p>
          
          <p>
            Quirke trophies is now under the new ownership of Patricia Quirke and Derek Cagney.
          </p>
          
          <p>
            We are delighted that Deirdre O'Brien, who has worked alongside John for over twenty five 
            years service is coming on board with the company. Together, we bring a wealth of business 
            and retail experience to the shop.
          </p>
          
          <p>
            We are proud to carry on John's tradition of service to the community and are delighted to 
            keep the legacy of his hard work alive.
          </p>
          
          <p>
            Our shop is based at Glengall House, the Square, Cahir. We provide bespoke trophies, cups 
            and memorabilia for all occasions. We are happy to work with you on designing the perfect 
            memento for any occasion.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;

